var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-menu-btn",class:{
        'app-menu-btn--close': _vm.value,
        'app-menu-btn--mobile': _vm.mobile,
      },on:{"click":function($event){return _vm.clickHandler()}}},[_c('div',{staticClass:"app-menu-btn__line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }